<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse"
                    aria-expanded="false" aria-controls="collapse">
                Uitgekeerde agioreserves in geld
            </button>
        </h2>
        <div id="collapse" class="accordion-collapse collapse" aria-labelledby="heading"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een agioreserve is een onderdeel van het eigen vermogen van een vennootschap en ontstaat wanneer
                aandelen worden uitgegeven boven de nominale waarde (de "pariwaarde") van die aandelen. Het extra bedrag
                bovenop de nominale waarde dat aandeelhouders betalen bij de uitgifte van aandelen, wordt geboekt op de
                agioreserve.

                <div class="space20"></div>
                ‘Uitgekeerde agioreserves in geld’ betekent dat een vennootschap een bedrag uit de agioreserve
                daadwerkelijk in contanten heeft uitbetaald aan aandeelhouders. Met andere woorden: het is
                een terugbetaling van kapitaal aan de aandeelhouders die oorspronkelijk is
                ingebracht bovenop de nominale waarde van aandelen (agio), en deze wordt uitgekeerd in geld, niet in
                natura (zoals aandelen of goederen).
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4"
                    aria-expanded="false" aria-controls="collapse4">
                Uitgekeerde agioreserves in bonusaandelen
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                ‘Uitgekeerde agioreserves in bonusaandelen’ betekent dat een vennootschap een deel van de agioreserve
                uitkeert aan haar aandeelhouders, niet in contanten, maar door het uitgeven van extra aandelen. Deze
                extra aandelen worden vaak gratis verstrekt aan de bestaande aandeelhouders, op basis van het aantal
                aandelen dat zij al bezitten.
                <div class="space20"></div>

                In principe is dit een vorm van kapitaalverhoging waarbij de vennootschap de agioreserve inruilt voor
                nieuwe aandelen. Hierdoor verhoogt de vennootschap het aantal uitstaande aandelen, maar verandert de
                waarde van de vennootschap in totaal niet, omdat de agioreserve wordt omgezet in aandelenkapitaal.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Stand agioreserve voor uitkering
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vermeld hier de stand van de agioreserve voordat de dividenduitkering plaatsvindt.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2"
                    aria-expanded="false" aria-controls="collapse2">
                Eerder ten onrechte vrijgestelde inkoop aandelen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Wanneer een vennootschap eigen aandelen inkoopt, kan dat in bepaalde gevallen worden aangemerkt als een
                kapitaaluitkering. Dit is relevant voor de dividendbelasting, omdat een kapitaaluitkering in sommige
                gevallen onderhevig is aan dividendbelasting, afhankelijk van de situatie.
                <div class="space20"></div>
                Als de vennootschap ten onrechte geen dividendbelasting heeft ingehouden bij de inkoop van de aandelen
                (bijvoorbeeld omdat de inkoop verkeerd werd behandeld), moet dit worden gecorrigeerd. Dit kan blijken
                uit de aangifte voor dividendbelasting, waarin de vennootschap deze ten onrechte vrijgestelde inkoop
                moet aangeven.
                <div class="space20"></div>
                Als de vennootschap ontdekt dat zij ten onrechte geen dividendbelasting heeft ingehouden bij de inkoop
                van aandelen, moet zij de correctie aanbrengen in haar aangifte voor dividendbelasting. Dit wordt dan
                aangeduid als "Eerder ten onrechte vrijgestelde inkoop van aandelen". De vennootschap moet dan alsnog de
                dividendbelasting afdragen over de ten onrechte vrijgestelde inkoop.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3"
                    aria-expanded="false" aria-controls="collapse3">
                Onbelast verbod op extraterritoriale heffing
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het verbod tot extra-territoriale belastingheffing verbiedt een staat om
                belasting te heffen van uitgedeelde en niet-uitgedeelde winsten van
                lichamen die geen inwoner zijn van die staat. De enkele omstandigheid
                dat dergelijke winst is verkregen op het grondgebied van een staat geeft
                die staat niet het recht deze inkomsten te belasten tenzij andere regels
                voor de verdeling van heffingsrechten in een verdrag dat uitdrukkelijk
                toestaan. Meer informatie hierover vind je in de Wet op de dividendbelasting 1965, artikel 1 lid 3 en de
                belastingverdragen tussen Nederland en andere landen.
                <div class="space20"></div>
                Vermeld het deel van de dividenduitkering dat onbelast is vanwege het verbod op
                extraterritoriale heffing.

            </div>
        </div>
    </div>

</div>
